import { DialogService } from '@sdbn/common';
import { ValidationMessageType } from '@sdbn/common';
import { ValidationMessage } from '@sdbn/common';
import { MatDialog } from '@angular/material/dialog';
import { AppServerAPI } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalTransportRegistration, TerminalTransportRegistrationResult } from '../../model/terminal/transport-registration.model';
import { BarcodeScan } from '@sdbn/tmc-common';

export class TransportRegistrationWithBarcodeController extends AbstractStepController {

  private dialogService: DialogService;
  appServerAPI: AppServerAPI;

  constructor(
  ) {
    super();
    this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {

  }

  onRegisterToDashboardContext() {

  }

  private validateRegistrationCodeAndGetTransportData() {
    const barcodeScan = new BarcodeScan({ value: this.dashboardContext.getContextValue('barcodeScanned') });
    this.appServerAPI.execute('/terminal/registration/transport/barcode', barcodeScan)
      .toPromise().then((response: TerminalTransportRegistrationResult) => {

        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        if (response.status !== ResponseStatus.FAILED) {

          const registration = new TerminalTransportRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
          this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
          this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
          this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
          this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, registration.phoneNumber);
          this.dashboardContext.setContextValue('string1', registration.string1);
          this.dashboardContext.setContextValue('string2', registration.string2);
          this.wizardComponent.next('transport-registration-masterdata');
        } else {
          const validationMessages = new Array<ValidationMessage>();
          for (const responseMessage of response.responseMessages) {
            validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
          }
          this.dashboardContext.setContextValue('validationMessages', validationMessages);
        }
      }, error => {
        // TODO specify what happens for bad codes
      });
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('registration code validation started');

    this.validateRegistrationCodeAndGetTransportData();

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const previousControl = new StepControl();
    previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    previousControl.type = StepControlType.BUTTON_STROKED;
    previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(previousControl);

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const newRegistrationControl = new StepControl();
    newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
    newRegistrationControl.type = StepControlType.BUTTON_STROKED;
    newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
    newRegistrationControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.next('transport-registration-masterdata');
    };
    controls.push(newRegistrationControl);

    return controls;
  }
}
